// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import { LiveRegionProvider } from '../../../components/accessibility';
import ColorsPage from './ColorsPage';
import ThemePage from './ThemePage';
import TypographyPage from './TypographyPage';
import TranslationsPage from './TranslationsPage';
import AccessibilityPage from './AccessibilityPage';

export default function SettingsRoutes() {
  return (
    <Routes>
      <Route path="colors" element={<ColorsPage />} />
      <Route path="theme" element={<ThemePage />} />
      <Route path="typography" element={<TypographyPage />} />
      <Route path="translations" element={<TranslationsPage />} />
      <Route
        path="accessibility"
        element={
          <LiveRegionProvider>
            <AccessibilityPage />
          </LiveRegionProvider>
        }
      />
    </Routes>
  );
}
